<template>
  <el-dialog
    title="Скопировать список баз"
    :visible="visible"
    width="30%"
    @update:visible="updateVisible">
    <p>Выберите дополнительных пользователей, которым нужно дать права доступа к выбранным базам</p>
    <checkbox-list
      class="mt-12"
      :list="users"
      :checked.sync="checkedUsers"
      :indeterminates="indeterminatedUsers"
      @update:checked="removeIndeterminates">
      <template v-slot="{ item }">
        <span class="text-bold mr-24">{{ item.name }}</span> <span class="text-muted">Логин: {{ item.login }}</span>
      </template>
    </checkbox-list>
    <span slot="footer" class="dialog-footer">
      <el-button
        :loading="$mip('addDatabasesToUsers')"
        type="primary"
        @click="sendAddToUsersRequest">
        Отправить
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { mapState } from 'vuex'
  import { isEqual, difference, intersection } from 'lodash-es'
  import CheckboxList from '@/components/CheckboxList.vue'

  export default {
    components: {
      CheckboxList
    },

    props: {
      visible: Boolean,
      checkedDatabases: Array
    },

    data() {
      return {
        checkedUsers: [],
        indeterminatedUsers: []
      }
    },

    computed: {
      ...mapState({
        users: state => state.users.users
      })
    },

    watch: {
      checkedDatabases(databases) {
        this.checkedUsers = this.users
          .filter(user => {
            return difference(databases, user.databasesIds).length === 0
          })
          .map(user => user.id)

        this.indeterminatedUsers = this.users
          .filter(user => {
            return intersection(databases, user.databasesIds).length > 0 && difference(databases, user.databasesIds).length > 0
          })
          .map(user => user.id)
      }
    },

    methods: {
      async sendAddToUsersRequest() {
        await this.$http.addDatabasesToUsers({ databasesIDs: this.checkedDatabases, usersIDs: this.checkedUsers })
        this.$store.dispatch('fetchUsers')
        this.updateVisible(false)
        this.$notify({
          title: 'Предоставление доступа',
          message: 'Заявка на предоставление пользователям прав доступа к базам отправлена',
          type: 'success'
        })
      },

      removeIndeterminates(ids) {
        this.indeterminatedUsers = this.indeterminatedUsers.filter(id => !ids.includes(id))
      },

      updateVisible(val) {
        this.$emit('update:visible', val)
      }
    }
  }
</script>